import {useTranslation} from "react-i18next";
import {Box} from "@material-ui/core";
import {ReactComponent as CheckActive} from "../../../../../vendor/icons/Check Active.svg";
import {ReactComponent as CheckInactive} from "../../../../../vendor/icons/Check Inactive.svg";
import React, {FC} from "react";
import styled from "styled-components/macro";
import {AccessibilityImages} from "../../../../../models/AccessibilityImages";
import {A11yItem} from "../../../../../models/utils";

const Label = styled.label`
    font-size:11px;
    padding-left:8px
`;

const MandatoryPicture = styled.div`
  font-weight: 500;
  margin-right: 8px;
  background-color:rgba(27, 38, 53, 0.4);
  min-width:191px;
  height:48px;
  display:flex;
  align-items:center;
  margin-bottom:11px;
  border-radius: 25px;
`;

type PictureGroupType = {
  images: AccessibilityImages[]
  mandatory: boolean,
  mainUnitImage?: boolean
  unitStandardValues: A11yItem[]
}

const PictureGroup: FC<PictureGroupType> = ({
  images,
  mandatory,
  mainUnitImage,
  unitStandardValues
}) => {
  const { t } = useTranslation();

  const getLabel = () => {
    if (mandatory) {
      return t("unitImagesDialog_labelMANDATORY")
    }
    return `${t("unitImagesDialog_labelOPTIONAL")} ${t("unitImagesDialog_labelPICTURES")}`
  }

  const isActive = (key: string, images: AccessibilityImages[]) => {
    if (images.length > 0) {
      return images.some((i) => i.items.includes(key)) ? <CheckActive/> : <CheckInactive/>
    }
    return <CheckInactive/>
  }

  const values = unitStandardValues.filter((i) => i.is_mandatory_image === mandatory)

  return (
    <div>
      {values.length ? <Label>{getLabel()}</Label> : null}
      {values.length > 0 ? (
        <Box p={4} display="flex" flexWrap="wrap">
          {mainUnitImage ? (
            <MandatoryPicture>
              <span style={{ paddingLeft: "11px" }}>{images.some((i) => i.is_general_image) ? <CheckActive/> : <CheckInactive/>}</span>
              <span style={{ paddingLeft: "11px", paddingRight: "11px" }}>{t('main_unit_image')}</span>
            </MandatoryPicture>
          ) : null}
          {values.map((i: any, index: any) =>
            <MandatoryPicture key={index}>
              <span style={{ paddingLeft: "11px" }}>{isActive(i.key, images)}</span>
              <span style={{ paddingLeft: "11px", paddingRight: "11px" }}>{i.title}</span>
            </MandatoryPicture>)}
        </Box>
      ) : null}
    </div>
  )
}

export default PictureGroup